import {
  buildOfficialDocument,
  ResponseOfficialDocument,
} from '@/shared/types/entities/OfficialDocument';
import {
  buildResultPublicationDocument,
  ResponseResultPublicationDocument,
} from '@/shared/types/entities/ResultPublicationDocument';
import { State } from '../index';
import { DOCUMENT_MUTATION } from './mutationTypes';

export const documentMutations = {
  [DOCUMENT_MUTATION.GET_OFFICIAL_DOCUMENT]: (
    state: State,
    data: { items: ResponseOfficialDocument },
  ) => {
    state.document.officialDocument = buildOfficialDocument(data.items);
  },
  [DOCUMENT_MUTATION.GET_RESULT_DOCUMENT]: (
    state: State,
    data: { items: ResponseResultPublicationDocument },
  ) => {
    state.document.resultPublicationDocument = buildResultPublicationDocument(
      data.items,
    );
  },
};
